// extracted by mini-css-extract-plugin
export var boxItems = "_74-1";
export var boxItemsLg = "_74-2";
export var button = "_74-7";
export var buttonHoverless = "_74-9";
export var buttonLg = "_74-8";
export var filterGroupBox = "_74-0";
export var icon = "_74-3";
export var iconSecondary = "_74-6";
export var iconWrapper = "_74-4";
export var iconWrapperLg = "_74-5";
export var truncatedLabel = "_74-a";